import { Component, Input, OnInit } from '@angular/core';
import { Roles } from 'src/app/models/user-role-enum';
import { MatDialog } from '@angular/material/dialog';
import { BookeeperModalComponent } from 'src/app/modules/dashboard/modals/bookeeper-modal/bookeeper-modal.component';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/modules/shared/services/notification/notification.service';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { EmployeeListService } from 'src/app/modules/shared/services/employee-list/employee-list.service';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.sass'],
})
export class TopNavComponent implements OnInit{
  @Input()
  userRole = Roles;
  unseenCount: any = 0;
  notifications: any[] = [];
  private checkNotificationInterval: any;
  reload = false;
  userName: string | undefined = '';
  profilePicUrl: string | undefined = '';

  rolSelected: any;
  roles: string[] = [];
  isHome: boolean = false;

  constructor(
    public dialog: MatDialog,
    public toastr: ToastrService,
    private router: Router,
    private notificationService: NotificationService,
    private msalService: MsalService,
    private readonly employeeservice: EmployeeListService
  ) {}

  ngOnInit(): void {
    this.getEmployeeName();
    this.checkRoles();
    sessionStorage.setItem('unseenCount', this.unseenCount);
    this.checkNotificationInterval = setInterval(async () => {
      await this.loadNotifications('N');
    }, 5000);
  }

  async getEmployeeName() {
    const account = this.msalService.instance.getActiveAccount();
    this.userName = account?.name;
    const email: any = account?.username;
    this.employeeservice.getProfilePicture(email).subscribe({
      next: (data: any) => {
        const blobUrl = URL.createObjectURL(data);
        this.profilePicUrl = blobUrl;
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  logout(): void {
    this.msalService.logoutRedirect();
    localStorage.getItem('formId')? localStorage.removeItem('formId') : '';
    localStorage.removeItem('employeeName');
    // this.showToasterMessage();
  }

  async loadNotifications(status: string){
    const user = localStorage.getItem('user');
    const count: any = Number(sessionStorage.getItem('unseenCount'));
    this.notificationService.getNotifications(status).subscribe({
      next: (data: any) => {
        if (user === 'BK') {
          this.notifications = data.filter((item: any) => !item.notificationTo);
        } else {
          this.notifications = data.filter((item: any) => item.notificationTo);
        }
        if (count !== this.notifications.length) {
          this.unseenCount = this.notifications.length;
        } else {
          this.unseenCount = 0;
        }
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  reloadNotification() {
    this.reload = !this.reload;
  }

  clearUnseenCount() {
    if (this.unseenCount !== 0) {
      sessionStorage.setItem('unseenCount', this.unseenCount);
    }
    this.unseenCount = 0;
    this.reloadNotification();
  }

  goToDashboard(){
    this.router.navigate(['dashboard']);
  }

  openBookeeperModal() {
    this.dialog
      .open(BookeeperModalComponent, {
        panelClass: 'yellow-border-dialog-surface',
        disableClose: true,
      })
      .afterClosed()
      .subscribe((res) => {
        if(res === 'yes'){
          sessionStorage.setItem('unseenCount', '0');
          if(localStorage.getItem('user') === 'BK'){
            localStorage.setItem('user', 'EMP');
            this.rolSelected = 'employee';
            this.router.navigate(['/dashboard/dashboard-employee']);
          } else {
            localStorage.setItem('user', 'BK');
            this.rolSelected = 'bookeeper';
            this.router.navigate(['/dashboard/dashboard-bookeeper']);
          }
        }

      });
  }

  showToasterMessage() {
    this.toastr.success(
      'Sie haben sich erfolgreich abgemeldet',
      '',
      {
        timeOut: 10000,
        closeButton: true,
      }
    );
    return true;
  }

  checkRoles() :void {
    const account: AccountInfo | null = this.msalService.instance.getActiveAccount();
    if (account && account.idTokenClaims) {
      this.roles = account.idTokenClaims['roles'] || [];
      this.roles = this.roles.flatMap(role => role.split(','));
    }

    if(this.roles?.includes('ROLE_BK') && this.roles?.includes('ROLE_EMP')){
      if(localStorage.getItem('user') === 'BK' || !localStorage.getItem('user')) {
        this.rolSelected = 'bookeeper';
      } else if (localStorage.getItem('user') === 'EMP'){
        this.rolSelected = 'employee';
      }
    } else if(this.roles?.includes('ROLE_EMP')){
      this.rolSelected = 'employee';
    }
  }

  checkVersionInfo(): void {
    if (this.router.url === '/dashboard' || this.router.url === 'dashboard/dashboard-bookeeper' || this.router.url === 'dashboard/dashboard-employee') {
      this.isHome = false;
      this.router.navigate(['/app-version']);
    } else {
      this.isHome = true;
      // do nothing, or show an alert, etc.
      this.router.navigate(['/dashboard']);
    }
  }
}
